/** Parsea una fila CSV respetando campos entre comillas */
export const parseCsvRow = (line: string): string[] => {
  const cells: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];
    const next = line[i + 1];

    if (char === '"') {
      if (inQuotes && next === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === ',' && !inQuotes) {
      cells.push(current.trim());
      current = '';
      continue;
    }

    current += char;
  }

  cells.push(current.trim());
  return cells;
};

export const parseCsv = (text: string): { headers: string[]; rows: string[][] } => {
  const lines = text.replace(/^\uFEFF/, '').trim().split(/\r?\n/).filter((line) => line.length > 0);
  if (lines.length === 0) {
    return { headers: [], rows: [] };
  }

  const headers = parseCsvRow(lines[0]);
  const rows = lines.slice(1).map(parseCsvRow);
  return { headers, rows };
};

export const limitCsvRows = (
  rows: string[][],
  maxRows: number
): { rows: string[][]; truncated: boolean; totalRows: number } => {
  const totalRows = rows.length;
  if (totalRows <= maxRows) {
    return { rows, truncated: false, totalRows };
  }
  return { rows: rows.slice(0, maxRows), truncated: true, totalRows };
};
